

















import Component from "vue-class-component";
import Vue from "vue";
import {Project, ProjectMetaData} from "../model/interface/project.interface";
import {Collection} from "../model/interface/collection.interface";
import {Prop, Watch} from "vue-property-decorator";
import ProjectHandleComponent from "./project-handle.vue";
import {Observer, Subject} from "../model/interface/subject-observer.interface";
import {ProjectService} from "../services/project.service";
import {MessageBus} from "../services/messageBus";
import {AlertType} from "../model/enum/alert.enum";

@Component({
  components: {ProjectHandleComponent}
})
export default class ProjectAddComponent extends Vue implements Observer {
  @Prop(Number) activateDialog!: number;
  @Prop(Array) projects!: ProjectMetaData[];

  private validate: number = 0;
  private project: Project = <Project>{
    groupOrUserId: null,
    alias: null,
    collection: <Collection>{
      key: null
    },
    apiKey: null,
    groupOrUserPrefix: null,
    maintainers: []
  };
  private showDialog: boolean = false;

  mounted() { }

  @Watch("activateDialog")
  onDialogChange(activateDialog: number) {
    this.showDialog = true;
  }

  private submitProject() {
    this.validate++;
  }

  async update(isValidated: boolean) {
    if (!isValidated)
      return;
    try {
      const project = await ProjectService.postProject(this.project);
      if(project) {
        MessageBus.$emit(AlertType[AlertType.success], `Project with ID ${project.id} successfully added!`);
        this.projects.push(project);
      }
    } catch(e) {
      MessageBus.$emit(AlertType[AlertType.error], 'Error during Project addition! ' + e);
    }
    this.showDialog = false;
    this.project = <Project>{
      groupOrUserId: null,
      alias: null,
      collection: <Collection>{
        key: null
      },
      apiKey: null,
      groupOrUserPrefix: null,
      maintainers: []
    };
  }

  private cancel() {
    this.project = <Project>{
      groupOrUserId: null,
      alias: null,
      collection: <Collection>{
        key: null
      },
      apiKey: null,
      groupOrUserPrefix: null,
      maintainers: []
    };
    this.showDialog = false;
  }

}
